import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class AttritionReasons extends Component {
    constructor() {
        super()
        this.state = {
            attritionReasonsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {

         let type="MANAGER_ATTRITION"
        
        if(this.props.type==="HR_ATTRITION"){
            type=this.props.type
        }
        
        this.getAttritionReasonsList(type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getAttritionReasonsList = (type) => {
        apiService.getAttritionReasonList(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        attritionReasonsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.attritionReasonsList).map((value,index) => {
            
            return {
                label : this.state.attritionReasonsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Reason"
                options={list}
                onChange={(e) => { (e) ? this.props.attritionReasonsChange(e) : this.props.attritionReasonsChange([])}}
                />
            </div>
        )
    }
}
export default AttritionReasons


// WEBPACK FOOTER //
// ./src/modules/Teams/Components/DropDowns/AttritionReasons.js